import React from 'react';
import _get from 'lodash/get';
import { bool, shape } from 'prop-types';
import { LocalStorage } from '../../shared/utils';
import l18n from '../../shared/strings';

import Tooltip from '../Tooltip';
import { DIFFERENT_VALUES } from '../../store/import/helpers/groupFields';

const PANELS_FIELD_NAME = window.inbox ? 'picsio.inboxPanelVisibility' : 'picsio.importPanelVisibility';

export const defaultPanelsState = window.inbox ? {
  inboxCommentVisibility: true,
  inboxDescriptionVisibility: true,
  inboxAssetMarksVisibility: true,
  inboxCustomFieldsVisibility: true,
} : {
  importCommentVisibility: true,
  importDescriptionVisibility: true,
  importKeywordsVisibility: true,
  importAssigneesVisibility: true,
  importAssetMarksVisibility: true,
  importCustomFieldsVisibility: true,
};

export const panelsVisibilityShape = window.inbox ? shape({
  inboxCommentVisibility: bool,
  inboxDescriptionVisibility: bool,
  inboxAssetMarksVisibility: bool,
  inboxCustomFieldsVisibility: bool,
}) : shape({
  importCommentVisibility: bool,
  importDescriptionVisibility: bool,
  importKeywordsVisibility: bool,
  importAssigneesVisibility: bool,
  importAssetMarksVisibility: bool,
  importCustomFieldsVisibility: bool,
});

export function getImportPanelVisibility() {
  try {
    return {
      ...defaultPanelsState,
      ...JSON.parse(LocalStorage.get(PANELS_FIELD_NAME) || {}),
    };
  } catch (err) {
    /** if can not get settings from local storage */
    return {};
  }
}

export function setImportPanelVisibility(data) {
  LocalStorage.set(PANELS_FIELD_NAME, JSON.stringify(data));
}

export function getRequiredAssetMarksNames(requiredFields) {
  const { flag, color, rating } = requiredFields;

  if (flag && color && rating) {
    return null;
  }
  if (flag && color) {
    return l18n.IMPORT.flagAndColor;
  }
  if (flag && rating) {
    return l18n.IMPORT.flagAndRating;
  }
  if (color && rating) {
    return l18n.IMPORT.colorAndRating;
  }
  if (color) {
    return l18n.IMPORT.colorOnly;
  }
  if (rating) {
    return l18n.IMPORT.ratingOnly;
  }
  if (flag) {
    return l18n.IMPORT.flagOnly;
  }
  return null;
}

export function getRequiredTitleAndDescriptionNames(requiredFields) {
  const { title, description } = requiredFields;

  if (title && description) {
    return null;
  }
  if (title) {
    return l18n.IMPORT.title;
  }
  if (description) {
    return l18n.IMPORT.description;
  }
  return null;
}

export function getIndicator(name, requireFields) {
  const isRequired = _get(requireFields, name);

  if (!isRequired) return null;
  return (
    <Tooltip content="Required fields" placement="top">
      <span className="isRequiredIndicator">
        * {(name === 'assetMarks' && <sup>{getRequiredAssetMarksNames(requireFields)}</sup>) || (name === 'titleAndDescription' && <sup>{getRequiredTitleAndDescriptionNames(requireFields)}</sup>)}
      </span>
    </Tooltip>
  );
}

export function getCustomTextFieldPlaceholder(value) {
  return value === DIFFERENT_VALUES
    ? l18n.DETAILS.placeholderMultipleSelection
    : l18n.DETAILS.placeholderCustomTextField;
}

export const isInbox = Boolean(window.inbox);
export const isInboxProtected = window?.inbox?.isProtected;
export const commentShow = isInbox ? Boolean(window?.inbox?.fields?.comment?.show) : true;
export const titleShow = isInbox ? Boolean(window?.inbox?.fields?.titleAndDescription?.show) : true;
export const colorShow = isInbox ? Boolean(window?.inbox?.fields?.color?.show) : true;
export const flagShow = isInbox ? Boolean(window?.inbox?.fields?.flag?.show) : true;
export const ratingShow = isInbox ? Boolean(window?.inbox?.fields?.rating?.show) : true;
export const marksShow = isInbox ? Boolean(colorShow || flagShow || ratingShow) : true;
const cfs = window?.inbox?.fields?.customFields || [];
export const customFieldsShow = isInbox ? Boolean(cfs.length && cfs.some(({ show }) => show)) : true;
